import { Component, Input, output } from '@angular/core';

import { ButtonComponent } from '../common/button/components/button/button.component';
import { DividerComponent } from '../common/divider/divider.component';

@Component({
  selector: 'rt-thread-expander',
  templateUrl: './thread-expander.component.html',
  styleUrls: ['./thread-expander.component.less'],
  imports: [ButtonComponent, DividerComponent],
})
export class ThreadExpanderComponent {
  @Input() public text: string;
  @Input() public withDivider: boolean = true;

  public expand = output();
}
